// Responsive variants for self-hosted images (see backend/image_variants.py).
// /images/listings/x.jpg → /images/_w/480/listings/x.jpg.webp 480w, /images/_w/960/... 960w
// External or unknown URLs get no srcset. Cards call dropVariants() on error so a
// missing variant falls back to the original file before any placeholder is used.
export const VARIANT_WIDTHS = [480, 960];

export function variantSrcSet(url) {
  if (typeof url !== "string" || !url.startsWith("/images/") || url.startsWith("/images/_w/")) return undefined;
  if (!/\.(jpe?g|png|webp)$/i.test(url)) return undefined;
  const rel = url.slice("/images/".length);
  // served via /i/ (static-server, 1-year immutable) rather than /images/ (nginx, 7 days)
  return VARIANT_WIDTHS.map((w) => `/i/_w/${w}/${rel}.webp ${w}w`).join(", ");
}

// First error: drop the srcset so the browser retries with the original src.
// Returns true when it did so (caller should not apply its own fallback yet).
export function dropVariants(img) {
  if (img && img.getAttribute("srcset")) { img.removeAttribute("srcset"); img.removeAttribute("sizes"); return true; }
  return false;
}
